export default __webpack_public_path__ + "static/media/logo_pixel.e07dc9b2.png";